import { auth } from "./auth";
import { payment } from "./payment";
import { reservation } from "./reservation";
import { check } from "./check";
import { logger } from "./logger";
import { service } from "./service";
import { bannerMessage } from "./bannerMessage";
import { updates } from "./updates";
import { reward } from "./reward";

import { appReview } from "./appReview";
import { combineReducers } from "redux";
import { userRole } from "./userRole";
import { userAppState } from "./userAppState";

export const rootReducer = combineReducers({
  auth,
  payment,
  reservation,
  check,
  logger,
  service,
  bannerMessage,
  updates,
  appReview,
  reward,
  userRole,
  userAppState,
});

export type RootState = ReturnType<typeof rootReducer>;
